'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$40() {
  this.bze = null;
  this.bzc = null;
  this.bzd = false;
  this.bza = null;
  this.bzb = false;
  this.bzf = false;
  this.bzg = false;
  this.bze = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_SitesView$$anon$40 as $c_Lpresto_SitesView$$anon$40 };
$p = $c_Lpresto_SitesView$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$40;
/** @constructor */
function $h_Lpresto_SitesView$$anon$40() {
}
export { $h_Lpresto_SitesView$$anon$40 as $h_Lpresto_SitesView$$anon$40 };
$h_Lpresto_SitesView$$anon$40.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bze;
});
$p.t = (function() {
  if ((!this.bzd)) {
    this.bzc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bzd = true;
  }
  return this.bzc;
});
$p.ae = (function() {
  if ((!this.bzb)) {
    this.bza = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bzb = true;
  }
  return this.bza;
});
$p.w = (function() {
  if ((!this.bzg)) {
    this.bzf = false;
    this.bzg = true;
  }
  return this.bzf;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_SitesView$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$40, "presto.SitesView$$anon$40", ({
  RI: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_SitesView$$anon$40 as $d_Lpresto_SitesView$$anon$40 };
//# sourceMappingURL=presto.-Sites-View$$anon$40.js.map
